// extracted by mini-css-extract-plugin
export default {"control":"LanguagePicker_control__ZhqLx","label":"LanguagePicker_label__YKQ8Q","icon":"LanguagePicker_icon__PcAZa"};